var styles = {"vatMessage":"ep-pricing-module-vat-message-dmF0L"};

export { styles as default };
